import { render, staticRenderFns } from "./SubsanarIcon.vue?vue&type=template&id=03556aaa&scoped=true"
var script = {}
import style0 from "./SubsanarIcon.vue?vue&type=style&index=0&id=03556aaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03556aaa",
  null
  
)

export default component.exports